export default __webpack_public_path__ + "static/media/login-illustration.b6a6f565.svg";